<template>
    <section class="card log-panel col-md-4 offset-md-4 col-10 offset-1 mt-md-0 mt-1">
        <header class="card-header log-panel-header">
         <div class="log-tab py-3"> <!-- py-3 temp untel we get  alogo -->
            <!-- <center><img width="125" alt="Customs logo" src="../../assets/logo.png" /></center> -->
             <center><img class="logo" alt="Customs logo" src="../../assets/full_logo.png" /></center>
             <br>
            <h5 class="text-dark-emphasis card-title text-center fw-bold">منظومة إدارة المركبات عبر المنافذ الحدودية</h5>
         </div>
      </header>
      <section class="card-body px-5">
          <LoginForm />
      </section>
    </section>
</template>
<script>
    import LoginForm from "@/components/Login/loginForm";
    import router from '@/router';
    export default {
        name: "AdminLogin",
        components: {
            LoginForm,
        },
        data(){
            return {
                empNo: "",
                password : "",
            }
        },
        methods: {
            async formSubmit(){ // async ماتنسى
            const formData = new FormData();
            formData.append("empNo", this.empNo)
            formData.append("password", this.password)
                try {
                const response = await this.$axios.post("api/employee/user/login", formData, {
                    withCredentials: true,
                });
                if (response.data?.isSuccess) {
                    const user = response.data.user;
                    this.$tempAlert(response.data?.msg ?? `تم الدخول بنجاح: ${user.firstName} ${user.lastName}`,'success');
                    sessionStorage.setItem("sess_exp", Date.now() + user.expireMinutes * 60000)
                    sessionStorage.setItem("user", JSON.stringify(user))
                    this.$store.commit('setUser',user);
                    setTimeout(()=>{
                        router.push("/admin/applicantsearch/")
                    }, 1000)
                } else {
                    this.$tempAlert(response.data?.msg ?? "البيانات غير صحيحة",'danger');
                }
                // Trigger the modal display
            } catch (error) {
                if(error.response?.data){
                    this.$tempAlert(error.response?.data.msg ?? "مشكلة في الاتصال بالخادم",'danger');
                }
                console.error("Submission error:", error);
            }
                
            },
            
        }
    }
</script>
<style>
 
.word-logo{
    width: 50vw;
    max-width: 300px;
}
.logo{
    width: 20vw;
    max-width: 200px;
}
</style>